import { Props, getImageUrls } from './images';

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const SearchProduct: React.FC<Props> = props => {
    const { fallBack, image } = getImageUrls(props, 'Products', true);

    return (
        <a className='search-product' href={props.url}>
            <span className='image-wrapper'>
                <Msdyn365.Image gridSettings={{}} quality={35} imageFallbackOptimize src={image} fallBackSrc={fallBack} />
            </span>
            <span className='product-name'>{props.Header}</span>
        </a>
    );
};
